import {
  AppstoreOutlined,
  ClusterOutlined,
  DashboardOutlined,
  GroupOutlined,
  ProjectOutlined,
} from "@ant-design/icons";

export const HomeIcon = (
  <div style={{ margin: 0 }}>
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ margin: "10px 0 0 0" }}
    >
      <g clipPath="url(#clip0_360_11469)">
        <path
          d="M0.75 12L12 0.75L23.25 12"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.25012 9.66016L3.25012 21.8601C3.25012 22.6301 3.21012 23.2501 4.59012 23.2501H19.5301C20.9101 23.2501 20.7501 22.6301 20.7501 21.8601V9.66016"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5 12H9.5V17H14.5V12Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_360_11469">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
);

export const ExploreIcon = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_329_2982)">
      <path
        d="M0.625 4.9582L6.875 1.44434L13.125 4.9582L19.375 1.44434V16.6805L13.125 20.1943L6.875 16.6805L0.625 20.1943V4.9582Z"
        stroke="#27187E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.875 1.44434V16.6805"
        stroke="#27187E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.125 4.95801V20.1941"
        stroke="#27187E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <ellipse
        cx="10.0138"
        cy="7.38831"
        rx="0.552639"
        ry="0.814683"
        transform="rotate(-31.1872 10.0138 7.38831)"
        fill="#758BFD"
      />
      <path
        d="M10.6241 9.46519H10.6246C10.6218 9.24207 10.5437 9.02643 10.403 8.85325C10.2623 8.68008 10.0672 8.55952 9.84932 8.51114C9.73044 8.50186 9.61269 8.53984 9.52165 8.61684C9.47229 8.66907 9.43392 8.73069 9.40882 8.79802C9.38371 8.86536 9.37239 8.93705 9.37551 9.00885C9.37536 9.01652 9.37567 9.02419 9.37642 9.03183L9.37505 9.04883V13.3659C9.37508 13.3752 9.37631 13.3845 9.37872 13.3935C9.39382 13.6156 9.48117 13.8268 9.62746 13.9946C9.77374 14.1625 9.97093 14.2779 10.1889 14.3232H10.1912C10.2485 14.326 10.3058 14.3171 10.3595 14.2971C10.4133 14.277 10.4623 14.2462 10.5037 14.2065C10.5499 14.1507 10.5844 14.0861 10.6052 14.0168C10.6259 13.9474 10.6325 13.8745 10.6246 13.8025L10.625 13.7942V9.48086L10.6241 9.46519Z"
        fill="#758BFD"
      />
    </g>
    <defs>
      <clipPath id="clip0_329_2982">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.819336)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const MapIcon = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ margin: "10px 3px 0px 1px" }}
  >
    <g clipPath="url(#clip0_298_9582)">
      <path
        d="M16.7168 3.47972C14.9607 1.72985 12.5821 0.748133 10.103 0.750003C7.62385 0.751872 5.24675 1.73717 3.49328 3.48969C1.73981 5.24221 0.753221 7.61878 0.750008 10.0979C0.746795 12.577 1.72722 14.9561 3.47614 16.7132L10.0213 23.2548C10.0487 23.2273 16.7111 16.7226 16.7111 16.7226C18.4677 14.9671 19.4551 12.5857 19.4561 10.1023C19.4572 7.61889 18.4718 5.23673 16.7168 3.47972V3.47972ZM10.0965 13.6146C9.40074 13.6142 8.72074 13.4075 8.14245 13.0207C7.56416 12.6339 7.11353 12.0844 6.84755 11.4415C6.58157 10.7986 6.51218 10.0913 6.64814 9.40897C6.78411 8.72665 7.11932 8.09997 7.61141 7.60815C8.1035 7.11633 8.73037 6.78146 9.41276 6.64587C10.0951 6.51028 10.8024 6.58006 11.4452 6.84639C12.0879 7.11272 12.6372 7.56365 13.0237 8.14215C13.4102 8.72066 13.6165 9.40076 13.6165 10.0965C13.6164 10.5586 13.5252 11.0162 13.3482 11.4431C13.1713 11.87 12.912 12.2579 12.5851 12.5846C12.2582 12.9112 11.8702 13.1703 11.4432 13.3471C11.0162 13.5238 10.5586 13.6147 10.0965 13.6146V13.6146Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2969 21.3231L18.2296 23.2548C18.2442 23.2401 21.7976 19.7709 21.7976 19.7709C22.6758 18.8896 23.1923 17.7115 23.2453 16.4686C23.2983 15.2256 22.884 14.0078 22.084 13.0551"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_298_9582">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AccessIcon = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_298_9591)">
      <path
        d="M8.73103 15.3936L8.7137 17.2087C8.365 17.3648 7.62707 17.677 6.22299 18.205C3.98068 19.0384 2.20973 19.6964 1.40866 20.8189C0.911855 21.6605 0.687085 22.6353 0.765164 23.6098"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="currentColor"
      />
      <path
        d="M15.2695 15.3936L15.2869 17.2087C15.6356 17.3648 16.3735 17.677 17.7776 18.205C20.0199 19.0384 21.7908 19.6964 22.5919 20.8189C23.0887 21.6605 23.3135 22.6353 23.2354 23.6098"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="currentColor"
      />
      <path
        d="M16.743 10.9191C16.743 13.7579 14.6197 17.1106 12.0004 17.1106C9.38115 17.1106 7.25781 13.7579 7.25781 10.9191"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.72158 8.1035C5.71411 7.87739 5.75465 7.65228 5.84051 7.44303C5.92638 7.23379 6.05561 7.04517 6.21967 6.88966C6.22218 5.3559 6.83234 3.88581 7.91619 2.80216C9.00003 1.7185 10.469 1.10986 12.0005 1.10986C13.5321 1.10986 15.001 1.7185 16.0848 2.80216C17.1687 3.88581 17.7789 5.3559 17.7814 6.88966C17.9454 7.04517 18.0747 7.23379 18.1605 7.44303C18.2464 7.65228 18.2869 7.87739 18.2795 8.1035H5.72158Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_298_9591">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.359863)"
        />
      </clipPath>
    </defs>
  </svg>
);

// export const ScenariosIcon = (
//   <svg
//     width="21"
//     height="20"
//     viewBox="0 0 21 20"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path d="M2.94336 17.5V2.5H17.9434V17.5H2.94336Z" stroke="#27187E" />
//     <path d="M5.44336 8.75V5H15.4434V8.75H5.44336Z" stroke="#758BFD" />
//     <path d="M5.44336 15V11.25H15.4434V15H5.44336Z" stroke="#758BFD" />
//     <circle cx="2.31836" cy="1.875" r="1.375" fill="white" stroke="#27187E" />
//     <circle cx="18.5684" cy="1.875" r="1.375" fill="white" stroke="#27187E" />
//     <circle cx="18.5684" cy="18.125" r="1.375" fill="white" stroke="#27187E" />
//     <circle cx="2.31836" cy="18.125" r="1.375" fill="white" stroke="#27187E" />
//   </svg>
// );

export const StakeholderIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_360_11377)">
      <path
        d="M8.51423 11.3106C9.91418 11.3091 11.2563 10.7518 12.2454 9.76113C13.2346 8.77045 13.7898 7.42751 13.7891 6.02756C13.7884 4.62762 13.2317 3.28526 12.2416 2.2956C11.2514 1.30594 9.90875 0.75 8.5088 0.75C7.10886 0.75 5.76621 1.30594 4.77604 2.2956C3.78587 3.28526 3.22924 4.62762 3.22852 6.02756C3.2278 7.42751 3.78305 8.77045 4.7722 9.76113C5.76135 10.7518 7.10342 11.3091 8.50337 11.3106H8.51423Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.75 23.2498V18.5947C0.752407 17.7723 1.08015 16.9843 1.66163 16.4028C2.24312 15.8214 3.0311 15.4936 3.85345 15.4912H13.1638C13.9861 15.4936 14.7741 15.8214 15.3556 16.4028C15.9371 16.9843 16.2648 17.7723 16.2672 18.5947V23.2498"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1367 11.1575C15.5936 11.3158 16.073 11.3996 16.5565 11.4056H16.5659C17.7731 11.4056 18.9309 10.9261 19.7846 10.0724C20.6382 9.21874 21.1178 8.06094 21.1178 6.8537C21.1178 5.64645 20.6382 4.48864 19.7846 3.63499C18.9309 2.78134 17.7731 2.30176 16.5659 2.30176C16.3868 2.30907 16.2084 2.32716 16.0315 2.35593"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.2496 21.6983V17.6851C23.2475 16.9762 22.9649 16.2969 22.4637 15.7956C21.9624 15.2944 21.2831 15.0118 20.5741 15.0098H18.1875"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_360_11377">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GuidanceIcon = (
  <div style={{ margin: 0 }}>
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ margin: "10px 3px 0 -3px" }}
    >
      <path
        d="M12 10C14.4853 10 16.5 7.98528 16.5 5.5C16.5 3.01472 14.4853 1 12 1C9.51472 1 7.5 3.01472 7.5 5.5C7.5 7.98528 9.51472 10 12 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 1.5C11.5 4 13.5 5 16 5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M4.5 17V15.75C4.5 12.99 6.74 10.75 9.5 10.75H14.5C17.26 10.75 19.5 12.99 19.5 15.75V17"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.822 9.93244L5.178 7.40139C4.85073 7.27671 4.5 7.51842 4.5 7.86863V19.6617C4.5 19.8662 4.62448 20.05 4.8143 20.126L11.8143 22.926C11.9335 22.9736 12.0665 22.9736 12.1857 22.926L19.1857 20.126C19.3755 20.05 19.5 19.8662 19.5 19.6617L19.5 7.86863C19.5 7.51842 19.1493 7.27671 18.822 7.40139L12.178 9.93244C12.0634 9.97611 11.9366 9.97611 11.822 9.93244Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 10V23"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3.25 13.7197C3.25 13.5984 3.34836 13.5 3.4697 13.5H4C4.9665 13.5 5.75 14.2835 5.75 15.25C5.75 16.2165 4.9665 17 4 17H3.4697C3.34836 17 3.25 16.9016 3.25 16.7803V13.7197Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M20.75 16.7803C20.75 16.9016 20.6516 17 20.5303 17L20 17C19.0335 17 18.25 16.2165 18.25 15.25C18.25 14.2835 19.0335 13.5 20 13.5L20.5303 13.5C20.6516 13.5 20.75 13.5984 20.75 13.7197L20.75 16.7803Z"
        fill=""
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  </div>
);

export const ConsultationsIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_329_3601)">
      <path
        d="M7.09519 9.42547C8.26182 9.42427 9.38021 8.95984 10.2045 8.13427C11.0288 7.30871 11.4915 6.18959 11.4909 5.02297C11.4903 3.85635 11.0264 2.73771 10.2013 1.913C9.37617 1.08829 8.25729 0.625 7.09067 0.625C5.92405 0.625 4.80517 1.08829 3.98003 1.913C3.15489 2.73771 2.69103 3.85635 2.69043 5.02297C2.68983 6.18959 3.15254 7.30871 3.97683 8.13427C4.80112 8.95984 5.91952 9.42427 7.08614 9.42547H7.09519Z"
        stroke="#27187E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M0.625 19.3747V15.4954C0.627006 14.8101 0.900122 14.1534 1.3847 13.6689C1.86927 13.1843 2.52592 12.9112 3.21121 12.9092H10.9698C11.6551 12.9112 12.3118 13.1843 12.7963 13.6689C13.2809 14.1534 13.554 14.8101 13.556 15.4954V19.3747"
        stroke="#27187E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.6143 9.29775C12.995 9.4297 13.3945 9.49951 13.7974 9.50453H13.8052C14.8112 9.50453 15.7761 9.10488 16.4875 8.3935C17.1988 7.68212 17.5985 6.71729 17.5985 5.71125C17.5985 4.70521 17.1988 3.74037 16.4875 3.02899C15.7761 2.31762 14.8112 1.91797 13.8052 1.91797C13.656 1.92406 13.5073 1.93914 13.3599 1.96311"
        stroke="#758BFD"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.3746 18.0816V14.7373C19.3729 14.1465 19.1375 13.5804 18.7197 13.1627C18.302 12.745 17.7359 12.5095 17.1451 12.5078H15.1562"
        stroke="#758BFD"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_329_3601">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ProgressIcon = (
  <div style={{ margin: 0, left: 15 }}>
    <svg
      width="16"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ margin: "10px 0 0 0" }}
    >
      <g clipPath="url(#clip0_360_11400)">
        <path
          d="M10.5205 13.7298L14.8405 9.02979"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.8904 0.75L14.1504 4.61L14.8404 9.03L19.2804 9.59L23.0204 5.73L18.7204 4.96L17.8904 0.75Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.2905 8.84998C11.7005 8.61998 11.0605 8.47998 10.3805 8.47998C7.42051 8.47998 5.02051 10.88 5.02051 13.84C5.02051 16.8 7.42051 19.2 10.3805 19.2C13.3405 19.2 15.7405 16.8 15.7405 13.84C15.7405 13.03 15.5405 12.26 15.2205 11.57"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1205 4.60994C11.5505 4.49994 10.9705 4.43994 10.3805 4.43994C5.19047 4.43994 0.980469 8.64994 0.980469 13.8499C0.980469 19.0499 5.19047 23.2499 10.3805 23.2499C15.5705 23.2499 19.7805 19.0399 19.7805 13.8499C19.7805 13.0899 19.6805 12.3499 19.5105 11.6399"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_360_11400">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
);

export const ProjectsIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_329_3142)">
      <path
        d="M13.9306 2.89977C12.4672 1.44154 10.4851 0.623444 8.41914 0.625002C6.35322 0.62656 4.37229 1.44765 2.91107 2.90808C1.44984 4.36851 0.627684 6.34899 0.625007 8.41491C0.622329 10.4808 1.43935 12.4634 2.89679 13.9276L8.35105 19.379C8.37389 19.3561 13.9259 13.9355 13.9259 13.9355C15.3897 12.4726 16.2126 10.4881 16.2135 8.4186C16.2143 6.34908 15.3932 4.36394 13.9306 2.89977V2.89977ZM8.41373 11.3455C7.83395 11.3452 7.26729 11.173 6.78538 10.8506C6.30347 10.5283 5.92795 10.0703 5.7063 9.53457C5.48465 8.99883 5.42682 8.40941 5.54012 7.84081C5.65342 7.27222 5.93277 6.74998 6.34285 6.34013C6.75292 5.93028 7.27531 5.65122 7.84397 5.53822C8.41263 5.42523 9.00202 5.48339 9.53763 5.70533C10.0732 5.92727 10.531 6.30304 10.8531 6.78513C11.1752 7.26722 11.3471 7.83397 11.3471 8.41375C11.347 8.79886 11.271 9.18017 11.1235 9.53592C10.9761 9.89167 10.76 10.2149 10.4876 10.4871C10.2152 10.7594 9.89186 10.9753 9.53602 11.1226C9.18019 11.2698 8.79883 11.3456 8.41373 11.3455V11.3455Z"
        stroke="#27187E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.5811 17.7689L15.1916 19.3787C15.2039 19.3665 18.165 16.4754 18.165 16.4754C18.8968 15.7411 19.3272 14.7593 19.3714 13.7235C19.4155 12.6877 19.0703 11.6729 18.4037 10.8789"
        stroke="#758BFD"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_329_3142">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const InternalMessagingIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_360_11384)">
      <path
        d="M14.5829 8.64648H2.24792C1.83936 8.64769 1.44788 8.81052 1.15898 9.09942C0.870087 9.38832 0.707256 9.7798 0.706055 10.1884V18.6686C0.707274 19.0772 0.87011 19.4687 1.159 19.7576C1.44789 20.0464 1.83936 20.2093 2.24792 20.2105H7.64445V23.2943L12.2701 20.2105H14.5829C14.9914 20.2093 15.3829 20.0465 15.6718 19.7576C15.9607 19.4687 16.1235 19.0772 16.1247 18.6687V10.1884C16.1235 9.77979 15.9607 9.3883 15.6718 9.09939C15.3829 8.81049 14.9914 8.64767 14.5829 8.64648V8.64648Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.875 5.82765V2.24794C7.87618 1.83937 8.039 1.44787 8.32791 1.15897C8.61681 0.870065 9.0083 0.707237 9.41687 0.706055H21.7518C22.1604 0.707256 22.5519 0.87009 22.8407 1.15899C23.1296 1.44789 23.2925 1.83938 23.2937 2.24794V10.7282C23.2925 11.1368 23.1296 11.5282 22.8407 11.8171C22.5518 12.106 22.1604 12.2689 21.7518 12.2701H20.6992V15.3538L18.9005 14.488"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_360_11384">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PlansAndForecastsIcon = (
  <div style={{ height: 35, width: "auto", marginLeft: -2 }}>
    <svg
      viewBox="0 0 50 50"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
    >
      <path
        style={{ fill: "currentColor", fillOpacity: 1 }}
        d="M4.277 40.409V33.46h11.83v13.895H4.277Zm9.858 0v-4.963H6.25v9.925h7.886zm4.93-7.444V18.574h11.829v28.782h-11.83zm9.857 0V20.559h-7.886V45.37h7.886zm4.93 3.97V26.514H45.68v20.842H33.85zm9.857 0v-8.436h-7.886V45.37h7.886zM9.206 26.36v-5.116L7.23 23.046l-1.98 1.801-.557-.56-.557-.561 3.028-3.32 3.027-3.32 3.028 3.32 3.027 3.32-.557.56-.557.561-1.977-1.801-1.978-1.802v10.232H9.206Zm29.574-6.947v-5.117l-1.977 1.802-1.978 1.802-.557-.56-.557-.562 3.027-3.32 3.028-3.32 3.028 3.32 3.027 3.32-.557.561-.557.561-1.977-1.802-1.978-1.802V24.53H38.78Zm-14.787-7.94V6.357l-1.977 1.801-1.978 1.802-.557-.56-.557-.561 3.028-3.32 3.027-3.321 3.028 3.32 3.027 3.32-.557.561-.557.561-1.977-1.802-1.978-1.801v10.232h-1.972z"
      />
    </svg>
  </div>
);

export const DashboardIcon = <DashboardOutlined />;

export const ScenariosIcon = <GroupOutlined />;

export const PortfoliosIcon = <ClusterOutlined />;

export const DsoDashboardIcon = <AppstoreOutlined />;

export const PlanningProgressIcon = <ProjectOutlined style={{marginLeft: "2px"}}/>;

export const HOMEICON_SSEN_LAEP = (
  <div style={{ margin: 0, display: "flex", alignItems: "center" }}>
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginRight: "-10px", width: 23, height: 23 }}
    >
      <path
        d="M3.25098 13.2148C3.25098 13.6719 3.60254 14.0674 4.16504 14.0674C4.4375 14.0674 4.68359 13.918 4.90332 13.7422L5.90527 12.8984V21.0723C5.90527 22.373 6.6875 23.1465 8.03223 23.1465H19.9238C21.2598 23.1465 22.0508 22.373 22.0508 21.0723V12.8545L23.1055 13.7422C23.3164 13.918 23.5625 14.0674 23.835 14.0674C24.3535 14.0674 24.749 13.7422 24.749 13.2324C24.749 12.9336 24.6348 12.6963 24.4062 12.5029L22.0508 10.5166V6.77246C22.0508 6.37695 21.7959 6.13086 21.4004 6.13086H20.1875C19.8008 6.13086 19.5371 6.37695 19.5371 6.77246V8.40723L15.2568 4.8125C14.4922 4.1709 13.5254 4.1709 12.7607 4.8125L3.60254 12.5029C3.36523 12.6963 3.25098 12.96 3.25098 13.2148ZM16.5312 15.6406C16.5312 15.2275 16.2676 14.9639 15.8545 14.9639H12.1631C11.75 14.9639 11.4775 15.2275 11.4775 15.6406V21.3975H8.49805C7.95312 21.3975 7.6543 21.0898 7.6543 20.5361V11.4307L13.6221 6.4209C13.8682 6.20996 14.1494 6.20996 14.3955 6.4209L20.293 11.3779V20.5361C20.293 21.0898 19.9941 21.3975 19.4492 21.3975H16.5312V15.6406Z"
        fill="currentColor"
      />
    </svg>
  </div>
);

export const MAPICON_SSEN_LAEP = (
  <div style={{ margin: 0, display: "flex", alignItems: "center" }}>
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginRight: "-10px", width: 20, height: 20 }}
    >
      <path
        d="M19.5029 4.05968C17.4541 2.01816 14.6791 0.872822 11.7868 0.875003C8.8945 0.877184 6.12121 2.0267 4.07549 4.07131C2.02978 6.11592 0.878758 8.88858 0.875009 11.7809C0.871261 14.6732 2.01509 17.4488 4.0555 19.4987L11.6915 27.1306C11.7234 27.0986 19.4962 19.5097 19.4962 19.5097C21.5456 17.4616 22.6976 14.6834 22.6988 11.786C22.7001 8.88871 21.5505 6.10952 19.5029 4.05968V4.05968ZM11.7792 15.8837C10.9675 15.8832 10.1742 15.6421 9.49953 15.1909C8.82485 14.7396 8.29913 14.0984 7.98882 13.3484C7.67851 12.5984 7.59755 11.7732 7.75617 10.9771C7.91479 10.1811 8.30588 9.44997 8.87999 8.87618C9.45409 8.30239 10.1854 7.9117 10.9816 7.75351C11.7777 7.59532 12.6028 7.67674 13.3527 7.98746C14.1025 8.29818 14.7434 8.82426 15.1943 9.49918C15.6452 10.1741 15.8859 10.9676 15.8859 11.7792C15.8858 12.3184 15.7794 12.8522 15.573 13.3503C15.3665 13.8483 15.064 14.3009 14.6826 14.682C14.3013 15.0631 13.8486 15.3654 13.3504 15.5716C12.8523 15.7778 12.3184 15.8838 11.7792 15.8837V15.8837Z"
        fill="currentColor"
      />
    </svg>
  </div>
);

export const GUIDANCEICON_SSEN_LAEP = (
  <div style={{ margin: 0, display: "flex", alignItems: "center" }}>
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        marginRight: "-10px",
        width: 23,
        height: 23,
        marginLeft: "-2px",
      }}
    >
      <path
        d="M20.4688 22.7334C21.5674 22.1973 21.8574 21.7051 21.8574 20.5537V7.11523C21.8574 5.6123 21.1631 4.90039 19.7217 4.90039H18.8867V4.66309C18.8867 3.73145 18.4121 3.23047 17.5684 3.23047C17.2871 3.23047 16.9531 3.30078 16.5664 3.43262C13.9121 4.28516 11.4863 4.85645 8.39258 4.85645H7.72461C6.71387 4.85645 6.14258 5.43652 6.14258 6.35938V21.4414C6.14258 22.1797 6.31836 22.6279 7.00391 22.9619C8.51562 23.6387 10.7656 24.0693 13.1035 24.0781C15.6523 24.0693 18.4912 23.6826 20.4688 22.7334ZM7.79492 20.6504V6.86914C7.79492 6.63184 7.91797 6.49121 8.14648 6.49121H8.56836C11.5391 6.49121 14.3691 5.87598 16.7861 5.12891C17.0674 5.03223 17.2432 5.11133 17.2432 5.375V18.3125C17.2432 18.7432 17.1816 18.9277 16.7686 19.2002C15.0107 20.4307 11.9697 21.1602 8.10254 20.9668C7.88281 20.958 7.79492 20.8613 7.79492 20.6504ZM18.0342 20.3164C18.7021 19.8066 18.8867 19.4375 18.8867 18.6201V6.55273H19.6777C20.0381 6.55273 20.2051 6.7373 20.2051 7.1416V20.3779C20.2051 20.8965 20.1172 21.1162 19.6162 21.3271C17.9111 22.0742 15.3975 22.5488 13.1035 22.5576C12.2422 22.5576 11.4072 22.5312 10.5635 22.4521C13.6748 22.2852 16.5752 21.415 18.0342 20.3164ZM9.49121 8.75V11.6504C9.49121 11.7822 9.59668 11.8525 9.70215 11.8525C11.7324 11.8525 13.8154 11.4922 15.3975 10.8594C15.4766 10.8242 15.5205 10.7451 15.5205 10.666V7.66016C15.5205 7.45801 15.3359 7.41406 15.2393 7.44922C13.4199 8.12598 11.6533 8.44238 9.70215 8.52148C9.5791 8.53027 9.49121 8.62695 9.49121 8.75Z"
        fill="currentColor"
      />
    </svg>
  </div>
);

export const DASHBOARDICON_SSEN_LAEP = (
  <div style={{ margin: 0, display: "flex", alignItems: "center" }}>
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        marginRight: "-10px",
        width: 23,
        height: 23,
        marginLeft: "-2px",
      }}
    >
      <path
        d="M4.38477 21.2568C4.38477 21.7139 4.68359 22.0127 5.14062 22.0127H22.7451C23.2197 22.0127 23.6152 21.6436 23.6152 21.1514C23.6152 20.6592 23.2197 20.29 22.7451 20.29H6.35352C6.16895 20.29 6.10742 20.2285 6.10742 20.0439V15.2627L9.83398 13.1006C10.1328 13.3818 10.5283 13.5576 10.9766 13.5576C11.3545 13.5576 11.7148 13.4258 11.9961 13.2061L13.6484 14.6123C13.5869 14.7881 13.5518 14.9814 13.5518 15.1748C13.5518 16.1064 14.2988 16.8535 15.2217 16.8535C16.1445 16.8535 16.9004 16.1064 16.9004 15.1748C16.9004 15.1045 16.8916 15.0254 16.8828 14.9551L20.9082 12.5469C21.1719 12.7314 21.4971 12.8369 21.8398 12.8369C22.7627 12.8369 23.5186 12.0811 23.5186 11.1582C23.5186 10.2354 22.7627 9.47949 21.8398 9.47949C20.917 9.47949 20.1611 10.2354 20.1611 11.1582C20.1611 11.2725 20.1787 11.3867 20.1963 11.4922L16.25 13.8564C15.9688 13.6367 15.6084 13.5049 15.2217 13.5049C14.9492 13.5049 14.6855 13.5664 14.4482 13.6895L12.6289 12.1426C12.6377 12.0547 12.6465 11.9668 12.6465 11.8789C12.6465 10.9561 11.8994 10.2002 10.9766 10.2002C10.0449 10.2002 9.29785 10.9561 9.29785 11.8789C9.29785 11.9053 9.29785 11.9316 9.29785 11.958L6.10742 13.8037V6.22754C6.10742 5.74414 5.73828 5.35742 5.24609 5.35742C4.75391 5.35742 4.38477 5.74414 4.38477 6.22754V21.2568Z"
        fill="currentColor"
      />
    </svg>
  </div>
);

export const PROGRESSTRACKERICON_SSEN_LAEP = (
  <div style={{ margin: 0, display: "flex", alignItems: "center" }}>
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        marginRight: "-10px",
        width: 23,
        height: 23,
        marginLeft: "-3px",
      }}
    >
      <path
        d="M9.66699 21.8809H18.2539C19.2031 21.8809 19.7568 21.3623 19.7568 20.4043V20.1406C19.7656 17.6885 17.1113 15.6934 16.0391 14.6738C15.7227 14.3574 15.5381 14.0762 15.5381 13.6543C15.5381 13.2324 15.7139 12.9688 16.0391 12.6436C17.1025 11.6064 19.7568 9.70801 19.7568 7.17676V6.93066C19.7568 5.97266 19.2031 5.4541 18.2539 5.4541H9.66699C8.74414 5.4541 8.23438 5.97266 8.23438 6.86914V7.17676C8.23438 9.70801 10.8887 11.6064 11.9434 12.6436C12.2773 12.9688 12.4531 13.2324 12.4531 13.6543C12.4531 14.0762 12.2686 14.3574 11.9434 14.6738C10.8799 15.6934 8.23438 17.6885 8.23438 20.1406V20.4658C8.23438 21.3623 8.74414 21.8809 9.66699 21.8809ZM10.6602 20.4922C10.2031 20.4922 10.0537 19.9736 10.4756 19.6572L13.4375 17.4336C13.5342 17.3633 13.5957 17.293 13.5957 17.1699V12.8457C13.5957 12.3799 13.4902 12.1426 13.1475 11.8438C12.6816 11.4395 11.7061 10.7275 11.249 10.1211C11.0732 9.88379 11.0908 9.69043 11.3018 9.69043H16.6807C16.8916 9.69043 16.918 9.88379 16.7422 10.1211C16.2852 10.7275 15.3096 11.4395 14.835 11.8438C14.4922 12.1338 14.3955 12.3799 14.3955 12.8457V17.1699C14.3955 17.293 14.457 17.3633 14.5537 17.4336L17.5156 19.6572C17.9463 19.9736 17.7793 20.4922 17.3311 20.4922H10.6602Z"
        fill="currentColor"
      />
    </svg>
  </div>
);

export const MANAGEACCESSICON_SSEN_LAEP = (
  <div style={{ margin: 0, display: "flex", alignItems: "center" }}>
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        marginRight: "-10px",
        width: 23,
        height: 23,
        marginLeft: "-2px",
      }}
    >
      <path
        d="M22.7363 14.252H23.501C23.7998 14.252 24.0371 14.0674 24.0986 13.7686L24.3096 12.9248C24.415 12.8896 24.5381 12.8457 24.6436 12.7842L25.3906 13.2412C25.6367 13.3906 25.9268 13.3906 26.1553 13.1621L26.6738 12.626C26.8848 12.415 26.9023 12.125 26.7354 11.8525L26.2959 11.1143C26.3662 11.0088 26.3926 10.9121 26.4365 10.8066L27.2803 10.5957C27.5791 10.5254 27.7725 10.2969 27.7725 9.99805V9.24219C27.7725 8.95215 27.5703 8.73242 27.2803 8.66211L26.4453 8.45117C26.4014 8.31934 26.3486 8.22266 26.3047 8.13477L26.7705 7.37012C26.9287 7.12402 26.9023 6.80762 26.6914 6.60547L26.1465 6.08691C25.9355 5.87598 25.6455 5.83203 25.3994 5.98145L24.6436 6.45605C24.5205 6.38574 24.415 6.35938 24.3096 6.31543L24.0986 5.4541C24.0283 5.16406 23.7998 4.9707 23.501 4.9707H22.7363C22.4375 4.9707 22.2002 5.17285 22.1387 5.46289L21.9453 6.30664C21.8047 6.35059 21.6992 6.38574 21.585 6.45605L20.8379 5.98145C20.6006 5.84082 20.3018 5.87598 20.0908 6.08691L19.5635 6.60547C19.3525 6.81641 19.2998 7.11523 19.458 7.37012L19.9326 8.13477C19.8887 8.22266 19.8447 8.33691 19.792 8.45117L18.957 8.66211C18.667 8.73242 18.4736 8.96094 18.4736 9.24219V9.99805C18.4736 10.2969 18.667 10.5254 18.957 10.5957L19.8096 10.8066C19.8535 10.9121 19.8975 11.0088 19.9414 11.1143L19.502 11.8613C19.3438 12.125 19.3613 12.4238 19.5723 12.626L20.0908 13.1621C20.3018 13.3906 20.6006 13.3906 20.8467 13.2412L21.6025 12.7842C21.7256 12.8545 21.8311 12.8896 21.9453 12.9248L22.1387 13.7686C22.2002 14.0586 22.4375 14.252 22.7363 14.252ZM6.81055 21.7666H21.3916C23.0879 21.7666 24.0723 20.7822 24.0723 18.9014V15.3066C23.5977 15.4121 22.8857 15.4209 22.3232 15.3066V18.752C22.3232 19.5957 21.875 20.0176 21.0664 20.0176H6.9248C6.11621 20.0176 5.66797 19.5957 5.66797 18.7432V12.0723H17.9551C17.709 11.5977 17.5244 11.0791 17.4365 10.5342H5.66797V8.33691C5.66797 7.53711 6.11621 7.11523 6.89844 7.11523H8.56836C9.19238 7.11523 9.56152 7.26465 10.0625 7.66895L10.5547 8.08203C11.1699 8.57422 11.6445 8.75 12.5674 8.75H17.4453C17.5156 8.12598 17.6562 7.58105 17.9551 6.99219H13.0332C12.4004 6.99219 12.0225 6.85156 11.5303 6.44727L11.0381 6.04297C10.4141 5.5332 9.95703 5.36621 9.03418 5.36621H6.54688C4.89453 5.36621 3.91895 6.33301 3.91895 8.1875V18.9014C3.91895 20.791 4.91211 21.7666 6.81055 21.7666ZM23.123 11.0703C22.3145 11.0703 21.6729 10.4199 21.6729 9.62012C21.6729 8.82031 22.3145 8.16992 23.123 8.16113C23.9141 8.14355 24.582 8.82031 24.582 9.62012C24.582 10.4199 23.9141 11.0703 23.123 11.0703Z"
        fill="currentColor"
      />
    </svg>
  </div>
);

export const STAKEHOLDERICON_SSEN_LAEP = (
  <div style={{ margin: 0, display: "flex", alignItems: "center" }}>
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        marginRight: "-10px",
        width: 23,
        height: 23,
        marginLeft: "-2px",
      }}
    >
      <path
        d="M7.13574 22.7861C7.62793 22.7861 8.05859 22.5752 8.66504 22.0566L11.5039 19.5254C12.1455 20.2021 13.1211 20.5713 14.3428 20.5713H17.3398L20.2666 23.0762C20.8467 23.5684 21.2422 23.8408 21.7168 23.8408C22.4111 23.8408 22.8242 23.3486 22.8242 22.584V20.5713H23.2197C25.4346 20.5713 26.9111 19.209 26.9111 16.9238V11.5801C26.9111 9.25977 25.4082 7.88867 23.1582 7.88867H21.6377V7.2998C21.6377 4.90918 20.1787 3.49414 17.7705 3.49414H4.96484C2.62695 3.49414 1.08887 4.90918 1.08887 7.2998V15.5264C1.08887 17.8818 2.60059 19.2793 4.90332 19.2793H6.01074V21.5381C6.01074 22.3115 6.42383 22.7861 7.13574 22.7861ZM7.56641 18.4443C7.56641 17.917 7.24121 17.6533 6.81055 17.6533H5.1582C3.69043 17.6533 2.81152 16.8271 2.81152 15.2979V7.48438C2.81152 5.94629 3.69922 5.12012 5.1582 5.12012H17.5684C19.0361 5.12012 19.915 5.94629 19.915 7.48438V7.88867H14.3428C12.0049 7.88867 10.5811 9.25977 10.5811 11.5801V16.9326C10.5811 17.3105 10.6162 17.6621 10.6953 17.9873L7.56641 20.9053V18.4443ZM21.2773 21.96L18.5088 19.4551C18.1309 19.1123 17.8145 18.9629 17.3047 18.9629H14.5186C13.1299 18.9629 12.2773 18.1895 12.2773 16.7217L12.2861 11.7383C12.2861 10.2793 13.1299 9.48828 14.5186 9.48828H22.9736C24.3711 9.48828 25.2148 10.2793 25.2148 11.7383V16.7217C25.2148 18.1807 24.3623 18.9629 22.9736 18.9629H22.0332C21.6025 18.9629 21.2773 19.2178 21.2773 19.7451V21.96ZM18.7549 15.2451C19.1943 15.2451 19.4404 14.999 19.458 14.5332L19.5811 11.6768C19.5986 11.1758 19.2383 10.8418 18.7461 10.8418C18.2539 10.8418 17.9023 11.1758 17.9287 11.668L18.043 14.5332C18.0605 14.9902 18.3066 15.2451 18.7549 15.2451ZM18.7549 17.9258C19.2822 17.9258 19.7041 17.5479 19.7041 17.0293C19.7041 16.5195 19.2822 16.1416 18.7549 16.1416C18.21 16.1416 17.7969 16.5283 17.7969 17.0293C17.7969 17.5391 18.2188 17.9258 18.7549 17.9258Z"
        fill="currentColor"
      />
    </svg>
  </div>
);

export const SCENARIOSICON_SSEN_LAEP = (
  <div style={{ margin: 0, display: "flex", alignItems: "center" }}>
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        marginRight: "-10px",
        width: 23,
        height: 23,
        marginLeft: "-2px",
      }}
    >
      <path
        d="M7.8125 10.8067L8.68262 9.68167L8.75293 9.72561C10.7568 11.0088 13.1123 13.9532 13.1123 16.0186V20.9405C13.1123 21.6084 13.4287 21.96 13.9912 21.96C14.5625 21.96 14.8789 21.6084 14.8789 20.9405V16.0186C14.8789 13.9532 17.2344 11.0088 19.2383 9.72561L19.2734 9.70803L20.0645 10.7979C20.46 11.3516 20.9785 11.2022 21.1895 10.5606L22.3408 7.10647C22.5166 6.57913 22.2266 6.18362 21.6816 6.19241L18.0342 6.22757C17.3662 6.23635 17.0762 6.6846 17.4629 7.22073L18.2188 8.25784C16.3115 9.55862 14.3516 12.0196 14.0088 13.3994H13.9824C13.6309 12.0108 11.6797 9.56741 9.78125 8.26663L10.5107 7.31741C10.9238 6.79007 10.6426 6.33303 9.96582 6.30667L6.32715 6.15725C5.78223 6.13968 5.4834 6.52639 5.6416 7.05374L6.6875 10.5342C6.88086 11.1846 7.39063 11.3516 7.8125 10.8067Z"
        fill="currentColor"
      />
    </svg>
  </div>
);

export const DSODASHBOARDICON_SSEN_LAEP = (
  <div style={{ margin: 0, display: "flex", alignItems: "center" }}>
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        marginRight: "-10px",
        width: 23,
        height: 23,
        marginLeft: "-2px",
      }}
    >
      <rect
        x="19.1492"
        y="11.0496"
        width="2.33062"
        height="8.54561"
        rx="0.388437"
        stroke="currentColor"
        stroke-width="0.776873"
      />
      <rect
        x="15.2647"
        y="13.3803"
        width="2.33062"
        height="6.21499"
        rx="0.388437"
        stroke="currentColor"
        stroke-width="0.776873"
      />
      <rect
        x="11.3804"
        y="15.7109"
        width="2.33062"
        height="3.88437"
        rx="0.388437"
        stroke="currentColor"
        stroke-width="0.776873"
      />
      <rect
        x="7.4961"
        y="17.2647"
        width="2.33062"
        height="2.33062"
        rx="0.388437"
        stroke="currentColor"
        stroke-width="0.776873"
      />
      <path
        d="M11.7687 21.9259H4.77687C4.34782 21.9259 4 21.5781 4 21.149V6.77687C4 6.34782 4.34782 6 4.77687 6H24.1987C24.6278 6 24.9756 6.34782 24.9756 6.77687V21.149C24.9756 21.5781 24.6278 21.9259 24.1987 21.9259H17.2068"
        stroke="currentColor"
        stroke-width="1.16531"
        stroke-linecap="round"
      />
      <path
        d="M4 9.10748H24.9756"
        stroke="currentColor"
        stroke-width="1.16531"
        stroke-linecap="round"
      />
      <path
        d="M5.55371 7.55371H13.7109"
        stroke="currentColor"
        stroke-width="0.388437"
        stroke-linecap="round"
      />
      <path
        d="M21.8679 7.55371L23.4217 7.55371"
        stroke="currentColor"
        stroke-width="0.388437"
        stroke-linecap="round"
      />
      <path
        d="M19.5374 7.55371L21.0911 7.55371"
        stroke="currentColor"
        stroke-width="0.388437"
        stroke-linecap="round"
      />
      <path
        d="M13.7107 21.9259H15.2644"
        stroke="currentColor"
        stroke-width="1.16531"
        stroke-linecap="round"
      />
    </svg>
  </div>
);

export const MASTERPLANICON_SSEN_LAEP = (
  <div style={{ marginTop: 10, marginLeft: 1 }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="0 0 18 17"
      fill="none"
    >
      <path
        d="M0.679932 4.07999C0.679932 4.07999 1.29811 4.07999 2.53448 4.07999C3.77084 4.07999 4.07993 3.51333 4.07993 2.66333C4.07993 1.81333 4.07993 0.679993 4.07993 0.679993"
        stroke="currentColor"
        strokeWidth="1.02"
        strokeLinecap="round"
      />
      <path
        d="M6.12 2.72003H10.2"
        stroke="currentColor"
        strokeWidth="1.02"
        strokeLinecap="round"
      />
      <path
        d="M0.51 3.57707C0.51 3.36889 0.586397 3.16796 0.724702 3.01236L2.69543 0.795291C2.85673 0.613826 3.08794 0.51 3.33073 0.51H10.88C11.3494 0.51 11.73 0.890558 11.73 1.36V15.64C11.73 16.1094 11.3494 16.49 10.88 16.49H1.36C0.890558 16.49 0.51 16.1094 0.51 15.64V3.57707Z"
        stroke="currentColor"
        strokeWidth="1.02"
      />
      <path
        d="M2.04004 8.16003H6.12004"
        stroke="currentColor"
        strokeWidth="1.02"
        strokeLinecap="round"
      />
      <path
        d="M2.04004 10.2H6.12004"
        stroke="currentColor"
        strokeWidth="1.02"
        strokeLinecap="round"
      />
      <path
        d="M2.04004 12.2401H6.12004"
        stroke="currentColor"
        strokeWidth="1.02"
        strokeLinecap="round"
      />
      <rect
        x="7.79582"
        y="6.3386"
        width="1.89429"
        height="6.94571"
        rx="0.315714"
        stroke="currentColor"
        strokeWidth="0.631428"
      />
      <path
        d="M11.5843 6.80705C11.3494 7.18679 10.3169 7.36625 9.77014 7.43848V12.4899H14.4257C15.2415 12.5238 15.6885 12.4899 16.0043 11.8585C16.32 11.227 16.6357 8.38561 16.6357 8.38561C16.6357 7.43848 16.0043 7.12276 15.3728 7.12276H13.4785L14.11 5.85991C14.4257 4.91276 13.1628 4.28133 12.5314 5.22848C11.9 6.17563 11.5843 6.80705 11.5843 6.80705Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="0.757714"
        strokeLinecap="round"
      />
    </svg>
  </div>
);
